<div class="widgets">
  <div class="title">
    <span class="title_left">
      <i class="fa fa-plus-circle" aria-hidden="true"></i>
      {{ 'HOME.ACCES_RAPIDE.TITLE' | translate }}
    </span>
  </div>

  <div class="scrollable-swipe" id="acces-rapide">
    @if (isLoading()) {
      <div class="loading-content center">
        <ion-icon name="sync" class="infinite-rotate"></ion-icon>
        <span>{{ 'GLOBAL.LOADING' | translate }}</span>
      </div>
    } @else {
      @if (isToggleTopInterventionEnabled()) {
        <acces-rapide-item
          [title]="'HOME.ACCES_RAPIDE.LINKS.TOP_INTERVENTION'"
          [iconName]="'top-securite'"
          (clickEvent)="goToTopIntervention()"
        ></acces-rapide-item>
      }
      @if (isOnline() && hasOtReleveP1()) {
        <acces-rapide-item
          data-test="acces-rapide-releves-p1"
          [title]="'HOME.ACCES_RAPIDE.LINKS.RELEVES_P1'"
          [iconName]="'speedometer-outline'"
          (clickEvent)="goToRelevesP1()"
        ></acces-rapide-item>
      }

      <acces-rapide-item
        [title]="'HOME.ACCES_RAPIDE.LINKS.DEMANDE_TRAVAUX'"
        [svgFileName]="'demande-de-travaux.svg'"
        [class.disabled]="!isOnline()"
        (clickEvent)="goToDemandeTravaux()"
      ></acces-rapide-item>

      <acces-rapide-item
        [title]="'HOME.ACCES_RAPIDE.LINKS.ACTIVITE_INTERNE'"
        [iconName]="'calendar-outline'"
        [class.disabled]="!isOnline()"
        (clickEvent)="startActiviteInterne()"
      ></acces-rapide-item>

      <acces-rapide-item
        data-test="acces-rapide-suggestion-ot"
        [title]="'HOME.ACCES_RAPIDE.LINKS.SUGGEST_OT'"
        [iconName]="'bulb-outline'"
        [class.disabled]="!this.isOnline()"
        (clickEvent)="goToSuggestOt()"
      ></acces-rapide-item>

      <acces-rapide-item
        [title]="'HOME.ACCES_RAPIDE.LINKS.RENFORT'"
        [iconName]="'people'"
        [class.disabled]="!isOnline()"
        (clickEvent)="startActiviteInterneRenfort()"
      ></acces-rapide-item>

      <acces-rapide-item
        [title]="'HOME.ACCES_RAPIDE.LINKS.INDISPO_IMMEDIATE'"
        [iconName]="'agenda-indisponibilite'"
        [class.disabled]="!isOnline()"
        (clickEvent)="startIndisponibilite()"
      ></acces-rapide-item>

      <acces-rapide-item
        [title]="'HOME.ACCES_RAPIDE.LINKS.PLANNING_EQUIPE'"
        [iconName]="'meeting'"
        [class.disabled]="!isOnline()"
        (clickEvent)="goToPlanningEquipe()"
      ></acces-rapide-item>

      <acces-rapide-item
        [title]="'HOME.ACCES_RAPIDE.LINKS.REGLEMENTAIRES'"
        [iconName]="'agenda-controle-reglementaire'"
        (clickEvent)="goToTournee('reglementaire')"
      ></acces-rapide-item>

      <acces-rapide-item
        [title]="'HOME.ACCES_RAPIDE.LINKS.CORRECTIFS'"
        [iconName]="'build-outline'"
        (clickEvent)="goToTournee('correctif')"
      ></acces-rapide-item>

      <acces-rapide-item
        [title]="'HOME.ACCES_RAPIDE.LINKS.TRAVAUX'"
        [iconName]="'shield'"
        (clickEvent)="goToTournee('travaux')"
      ></acces-rapide-item>
    }
  </div>
</div>
